import { FuseScrollbars } from '@fuse';
import { useForm, useUpdateEffect } from '@fuse/hooks';
import _ from '@lodash';
import { Button, Input, Tooltip, Typography } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import moment from 'moment';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import AnotacaoModel from '../Model/AnotacaoModel';
import AnotacaoFormList from './CheckList/AnotacaoFormList';

function AnotacaoForm(props) {
    const [showList, setShowList] = useState(false);
    const { form: anotacaoForm, handleChange, setForm } = useForm(
        _.merge(
            {},
            new AnotacaoModel(),
            props.anotacao
        ));
    const { onChange } = props;

    useUpdateEffect(() => {
        if (anotacaoForm && onChange) {
            onChange(anotacaoForm);
        }
    }, [anotacaoForm, onChange]);

    function handleOnCreate(event) {
        if (!props.onCreate) {
            return;
        }
        props.onCreate({ ...anotacaoForm, usrupt: sessionStorage.getItem("displayname"), dataupt: new Date().toISOString() });
    }

    function handleToggleList() {
        setShowList(!showList);
    }

    function handleChecklistChange(checklist) {
        setForm(_.setIn(anotacaoForm, `checklist`, checklist));
    }

    function handleArchiveToggle() {
        //setForm(_.setIn(anotacaoForm, `archive`, !anotacaoForm.archive));
        setForm(_.setIn(anotacaoForm, 'arquivado', !anotacaoForm.arquivado));
        if (props.variant === "new") {
            setTimeout(() => handleOnCreate());
        }
    }

    function newFormButtonDisabled() {
        return anotacaoForm.titulo === "" && anotacaoForm.descricao === "" && anotacaoForm.checklist.length === 0;
    }

    if (!anotacaoForm) {
        return null;
    }

    return (
        <div className="flex flex-col w-full">
            <FuseScrollbars className="flex flex-auto w-full max-h-640">
                <div className="w-full">
                    <div className="px-16 pt-12">
                        <Input
                            className="font-bold"
                            placeholder="Título"
                            type="text"
                            name="titulo"
                            value={anotacaoForm.titulo}
                            onChange={handleChange}
                            disableUnderline
                            fullWidth
                        />
                    </div>
                    <div className="px-16 pt-8">
                        <Input
                            placeholder="Anotação"
                            multiline
                            rows="4"
                            name="descricao"
                            value={anotacaoForm.descricao}
                            onChange={handleChange}
                            disableUnderline
                            fullWidth
                            autoFocus
                        />
                    </div>

                    {(anotacaoForm.checklist.length > 0 || showList) && (
                        <div className="px-16 pt-8">
                            <AnotacaoFormList checklist={anotacaoForm.checklist} onCheckListChange={handleChecklistChange} />
                        </div>
                    )}
                    {(anotacaoForm.dataupt) && (
                        <div className="block w-full px-16 pt-8">
                            <Typography color="textSecondary" className="text-12" style={{ textAlign: "end" }}>
                                Atualizado: {moment(anotacaoForm.dataupt).format('DD MMM YYYY, HH:MM ')}
                            </Typography>
                            
                        </div>
                    )}
                </div>
            </FuseScrollbars>

            <div className="flex flex-auto justify-between items-center h-48">
                <div className="flex items-center px-4">
                    <Tooltip title="Add checklist" placement="bottom">
                        <XAPPButton
                            className="w-32 h-32 mx-4 p-0"
                            onClick={handleToggleList}
                            type={"icon"}
                            icon="checklist_add"
                        />
                    </Tooltip>
                    {props.variant === "edit" &&
                        <Tooltip title={anotacaoForm.arquivado ? "Desarquivar" : "Arquivar"} placement="bottom">
                            <div>
                                <XAPPButton
                                    type={"icon"}
                                    icon="checklist_add"
                                    className="w-32 h-32 mx-4 p-0"
                                    onClick={handleArchiveToggle}
                                    disabled={newFormButtonDisabled()}
                                    icon={anotacaoForm.arquivado ? "desarquivar" : "arquivar"}
                                />
                            </div>
                        </Tooltip>
                    }
                </div>
                <div className="flex items-center px-4">
                    <Button
                        className="m-4"
                        onClick={(ev) => {
                            handleOnCreate(ev);
                            if (props.variant === "edit") {
                                props.onClose();
                            }
                        }}
                        variant="outlined"
                        size="small"
                        disabled={newFormButtonDisabled()}
                    >
                        {"Adicionar"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

AnotacaoForm.propTypes = {};
AnotacaoForm.defaultProps = {
    variant: "edit",
    anotacao: null
};

export default withRouter(AnotacaoForm);
